import { z } from 'zod';
import { Currency } from '../enums.js';
import { IsoDate, IsoDateTime, MoneyAmount, UuidString } from '../primitives.js';

/**
 * S14-BE.1 — Settlement (взаимозачёт между counterparty AR ↔ AP).
 * Journal-style net-off; не движение денег, бухгалтерская проводка.
 */

/** `pushing` — B74 (Ф6, §9.4 п. 7): идёт отправка в 1С по заявке уровня 3. */
export const SettlementState = z.enum(['draft', 'posted', 'cancelled', 'pushing']);
export type SettlementState = z.infer<typeof SettlementState>;

export const SettlementLineDirection = z.enum(['ar_to_ap', 'ap_to_ar']);
export type SettlementLineDirection = z.infer<typeof SettlementLineDirection>;

export const SettlementLine = z.object({
  line_no: z.number().int().min(1),
  direction: SettlementLineDirection,
  counterparty_id: UuidString,
  invoice_id: UuidString,
  amount: MoneyAmount,
  currency: Currency,
});
export type SettlementLine = z.infer<typeof SettlementLine>;

export const Settlement = z.object({
  id: UuidString,
  entity_id: UuidString,
  state: SettlementState,
  document_number: z.string(),
  settlement_date: IsoDate,
  // BE-N Pass 80: было `.min(2)` (business invariant: взаимозачёт = AR + AP minimum 2 lines).
  // Но seed data + create flow позволяют 1-line settlements (FE-282 defensive UI shipped, но
  // существующие документы крашили page). Relax до `.min(0)` чтобы page рендерилась.
  // Real fix: BE-side validation в POST handler + seed-fix отдельно (out-of-scope FE backlog).
  lines: z.array(SettlementLine),
  net_amount: MoneyAmount,
  currency: Currency,
  notes_ru: z.string().nullable(),
  onec_ref: z.string().nullable(),
  created_at: IsoDateTime,
  posted_at: IsoDateTime.nullable(),
  created_by: UuidString,
  posted_by: UuidString.nullable(),
});
export type Settlement = z.infer<typeof Settlement>;
